import api from "../services/api";

/** Resuelve teléfono/email de un comprador del expediente. */
export async function resolverContactoComprador(c) {
  const base = {
    tipo: "comprador",
    nombre: [c.nombre, c.apellidos].filter(Boolean).join(" ").trim(),
    telefono: c.telefono || c.whatsapp || "",
    email: c.email || "",
    cliente_id: c.cliente_id || null,
    lead_id: c.lead_id || null,
  };
  if (base.telefono && base.email) return base;

  if (c.cliente_id) {
    try {
      const r = await api.get(`/clientes/${c.cliente_id}`);
      const cl = r.data?.data || r.data;
      if (cl) {
        return {
          ...base,
          telefono: base.telefono || cl.telefono || cl.whatsapp || cl.telefono_secundario || "",
          email: base.email || cl.email || "",
          nombre: base.nombre || [cl.nombre, cl.apellido].filter(Boolean).join(" ").trim(),
        };
      }
    } catch { /* */ }
  }

  if (c.lead_id) {
    try {
      const r = await api.get(`/leads/${c.lead_id}`);
      const ld = r.data?.data || r.data;
      if (ld) {
        return {
          ...base,
          telefono: base.telefono || ld.telefono || ld.whatsapp || "",
          email: base.email || ld.email || "",
          nombre: base.nombre || [ld.nombre, ld.apellido].filter(Boolean).join(" ").trim(),
        };
      }
    } catch { /* */ }
  }

  return base;
}

/** Resuelve teléfono/email de un propietario del expediente. */
export async function resolverContactoPropietario(p) {
  const base = {
    tipo: "propietario",
    nombre: [p.nombre, p.apellidos].filter(Boolean).join(" ").trim(),
    telefono: p.telefono || "",
    email: p.email || "",
    contacto_id: p.contacto_id || null,
  };
  if ((base.telefono && base.email) || !p.contacto_id) return base;

  try {
    const r = await api.get(`/contactos/${p.contacto_id}`);
    const ct = r.data?.data || r.data;
    if (ct) {
      return {
        ...base,
        telefono: base.telefono || ct.telefono || "",
        email: base.email || ct.email || "",
        nombre: base.nombre || [ct.nombre, ct.apellidos].filter(Boolean).join(" ").trim(),
      };
    }
  } catch { /* */ }

  return base;
}

export function contactoParaModal(c) {
  const iniciales = (c.nombre || "?").slice(0, 2).toUpperCase();
  return {
    nombre: c.nombre || "Contacto",
    telefono: c.telefono || "",
    email: c.email || "",
    iniciales,
  };
}

export async function resolverContactosSeleccionados(compradores, propietarios, selComp, selProp) {
  const out = [];
  for (const i of selComp) {
    const c = compradores[i];
    if (c) out.push(await resolverContactoComprador(c));
  }
  for (const i of selProp) {
    const p = propietarios[i];
    if (p) out.push(await resolverContactoPropietario(p));
  }
  return out;
}

export async function llamarContacto(contacto, { clienteId, leadId } = {}) {
  const telefono = contacto?.telefono;
  if (!telefono) throw new Error("El contacto seleccionado no tiene teléfono.");
  const data = await api.post("/telnyx/llamar", {
    telefonoCliente: telefono,
    clienteId: clienteId || contacto.cliente_id || null,
    leadId: leadId || contacto.lead_id || null,
    vincularCitaPendiente: false,
  }).then((r) => r.data);
  if (!data.ok) throw new Error(data.error || "No se pudo iniciar la llamada");
  return data;
}
